import { HelperConstant } from '../../helpers/HelperConstant';
import { useTypedDispatch } from 'features/reduxhooks/ReduxHooks';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react'
import { Alert, Card, CardBody, Col, Row, UncontrolledAlert } from 'reactstrap'
import SignPad from "react-signature-canvas";
import { pageChange } from 'features/reducers/DocumentScan/PageChange.Reducer';
import { useNavigate } from 'react-router-dom';
import { getPersonId } from '../../helpers/TokenHelper';
import CommonService from 'services/CommonService';
import { CustomButton } from 'components/shared/CustomButton';
import { currencyByCountry, isMobile, toAmount } from '../../helpers/Helper';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    statusId: number,
    data?: IGetOrderSummaryModel | undefined,
    encryptedOrderId: any,
    activeTab: any,
    setActiveTab: any
}

function SignaturePad({ statusId, data, encryptedOrderId, activeTab, setActiveTab, ...rest }: inputProps, ref) {
    let dispatch = useTypedDispatch();
    const navigate = useNavigate();

    const signatureCanvas = useRef({} as SignPad);
    const [orderPayoutData, setOrderPayoutData] = useState<any>();
    const [ImageSignature, setImageSignature] = useState<any>();
    const [signatureValidation, setsignatureValidation] = useState<boolean>(false);
    const [successToast, setSuccessToast] = useState(false);
    const [sign, setSign] = useState<any>();
    const signatureTypeId = HelperConstant.documentTypeId.Signature;
    const [photostype] = useState({ signature: "signature.png" });
    const [showEdit, setShowEdit] = useState(true);
    const [isReferral, setIsReferral] = useState<boolean>(false);
    const [isRender, setIsRender] = useState<boolean>(false);

    const submitHandler = () => {
        setActiveTab(5)
        dispatch(pageChange("OtpScreen"));
    }

    const clear = () => { signatureCanvas.current?.clear(); }

    const SkipOTP = () => {
        const data = {
            OrderId: 0,
            personId: 0,
            password: 0,
            emailTemplateId: 0
        };

        CommonService.postWithFormDataWithQueryParam('sell', 'SkipOTP', data, "encryptedOrderId", encryptedOrderId, "application/json").then(res => {
            if (res.status === 200 && res.data === true) {
                setSuccessToast(true);
                navigate(`/success-screen/${encryptedOrderId}`)
            }
        }).catch(e => console.log(e));
    }

    const dataURLtoFile = (dataurl: any, filename: string) => {
        let arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };

    const save = (photostypes: any, signatureTypeId: any, skipOtp: boolean) => {
        if (signatureCanvas.current.isEmpty()) {
            setsignatureValidation(true)
        }
        else {
            const imgSave = signatureCanvas.current?.getTrimmedCanvas().toDataURL("image/png");
            const imageFile = dataURLtoFile(imgSave, photostypes);
            dataURLtoFile(imgSave, photostypes);
            setSign(imgSave);

            const formData = new FormData();
            formData.append("OrdersId", '0');
            formData.append("DocumentTypeId", signatureTypeId);
            formData.append("DocumentPath", "");
            formData.append("RowOrder", "100");
            formData.append("UploadFiles", imageFile);
            formData.append("FileName", imageFile.name);
            formData.append("Specifics", "10");

            CommonService.postWithFormDataWithQueryParam('OrderDocuments', 'AddOrderDocument', formData, "encryptedOrderId", encryptedOrderId, "multipart/form-data").then((res) => {
                if (res.status === 200) {
                    // close();
                    if (skipOtp === true) {
                        SkipOTP();
                    }
                    else {
                        submitHandler();
                    }
                }
            }).catch(e => {
                console.log(e);
            });
        }
    };

    const deleteImage = (signatureData: any) => {
        CommonService.postWithDoubleParam("OrderDocuments", "DeleteOrderDocument", "orderId", encryptedOrderId, "documentTypeId", signatureData).then(res => {
            if (res.status === 200) {
                setImageSignature("");
            }
        }).catch(e => {
            console.log(e);
        });
    }

    useEffect(() => {
        const GetDisplayDocuments = () => {
            CommonService.getWithQueryParam("Sell", "GetOrderPayout", "orderId", encryptedOrderId).then((res) => {
                if (res.status === 200) {
                    setIsRender(true);
                    setOrderPayoutData(res.data);
                }
            }).catch(e => {
                console.log(e);
            });

            CommonService.postWithDoubleParam("OrderDocuments", "GetBase64OrderDocument", "orderId", encryptedOrderId, "documentTypeId", signatureTypeId).then(res => {
                if (res.status === 200) {
                    if (res.data !== null) {
                        var base64ImageString = `data:image/png;base64,${res.data}`;
                        setImageSignature(base64ImageString);
                        if ((statusId === HelperConstant.StatusId.CANCELLED || statusId === HelperConstant.StatusId.COMPLETED || statusId === HelperConstant.StatusId.FAILED) && res?.data?.length > 0) {
                            setShowEdit(false);
                        }
                    }
                    else {
                        setImageSignature("");
                    }
                }
            }).catch(e => {
                if (e == 'Request failed with status code 401') {
                    navigate('/logout')
                } else {
                    console.error("API error:", e);
                }
            });
        }

        GetDisplayDocuments();
    }, [encryptedOrderId, signatureTypeId, statusId]);

    return (
        <React.Fragment>
            {isRender ?
                <Card>
                    <CardBody>
                        <div className='mb-2'>
                            <i className='fas fa-hashtag text-dofy me-2 font-size-15'></i>
                            <span className='font-size-16 fw-semibold text-dofy'>Signature Pad</span>
                        </div>
                        <div className='mb-2'>
                            <Row>
                                <Col xl={3}>
                                    <p className='font-size-12 fw-semibold text-muted'> Final Selling Price </p>
                                </Col>
                                <Col xl={6}>
                                    <h5 className='fw-bold text-dofy '> {currencyByCountry(toAmount(orderPayoutData?.TotalAmount))}/-</h5>
                                </Col>

                            </Row>
                        </div>

                        {ImageSignature ?
                            <Card className='shadow-none' style={{ border: '2px solid #ebf5f7' }}>
                                <CardBody className=''>
                                    <img src={ImageSignature} alt='signature' style={{ width: 200, height: 150 }} />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Signature</span >
                                        {showEdit ?
                                            <i className='fas fa-trash font-size-18 text-danger cursor-pointer' onClick={() => deleteImage(signatureTypeId)} slot="end" />
                                            : null}
                                    </div>
                                </CardBody>
                            </Card>
                            : <>
                                <div>
                                    <SignPad ref={signatureCanvas} canvasProps={{ className: signatureValidation ? "signatureCanvas-error" : "signatureCanvas" }} />
                                </div>
                                {signatureValidation ?
                                    <div>
                                        <i className='mdi mdi-alert-outline me-2 fw-bold text-danger'></i>
                                        <span className='font-size-12 fw-bold text-danger'>Your Signature is required</span>
                                    </div> : null}
                                <Row>
                                    <Col>
                                        {!isMobile() ?
                                            <div className='d-flex flex-wrap justify-content-end my-1'>
                                                <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={''} name={'Previous'} onClick={() => { setActiveTab(3); dispatch(pageChange('Adjustment')) }} />
                                                <CustomButton type={'button'} btnClassName={'btn-secondary me-2'} iconClasssName={undefined} name={'Clear'} onClick={clear} />
                                                <CustomButton
                                                    type="button"
                                                    btnClassName="btn-info me-2"
                                                    iconClasssName={undefined}
                                                    name="Skip Otp & Complete"
                                                    onClick={(e) => {
                                                        e.target.disabled = true; 
                                                        save(photostype.signature, signatureTypeId, true);
                                                    }}
                                                />

                                                <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Save & Continue'} onClick={() => save(photostype.signature, signatureTypeId, false)} />
                                            </div> :
                                            <div className='d-flex flex-column gap-2'>
                                                <CustomButton type={'button'} btnClassName={'btn-light btn-lg mt-2'} iconClasssName={''} name={'Previous'} onClick={() => { setActiveTab(3); dispatch(pageChange('Adjustment')) }} />
                                                <CustomButton type={'button'} btnClassName={'btn-secondary btn-lg'} iconClasssName={undefined} name={'Clear'} onClick={clear} />
                                                <CustomButton type={'button'} btnClassName={'btn-info btn-lg'} iconClasssName={undefined} name={'Skip Otp & Complete'}
                                                 onClick={(e) => { e.target.disabled = true; save(photostype.signature, signatureTypeId, true)}} />
                                                <CustomButton type={'button'} btnClassName={'btn-success btn-lg'} iconClasssName={undefined} name={'Save & Continue'} onClick={() => save(photostype.signature, signatureTypeId, false)} />
                                            </div>}
                                    </Col>
                                </Row>
                            </>}
                    </CardBody>
                </Card> : <></>}
        </React.Fragment>
    )
}

export default SignaturePad
